import { cloneDeep } from 'lodash'
import { useAuthContext } from '../contexts/AuthContext'
import navConfig from '../layouts/dashboard/nav/config-navigation'

const useRolMenu = () => {

    let userMenuConfig = []
    
    const { user } = useAuthContext()
    const idRol = user?.rol_id

    navConfig.map((mod) => {
        
        if(mod.mod_roles.includes(idRol)){

            const newMod = {...mod}
            const newItems = []

            newMod.items.map((submod) => { 

                const newSubmod = {...submod }

                if(newSubmod.mod_roles?.includes(idRol)){

                    const newChildren = []
                    
                    if(newSubmod.children){
                        newSubmod.children.map((child) => {
                            if(child.mod_roles?.includes(idRol)){
                                newChildren.push(child)
                            }
                            return true
                        })
                        newSubmod.children = newChildren
                    }
                    newItems.push(newSubmod)
                }
                return true
            })

            newMod.items = newItems
            userMenuConfig.push(newMod)
        }
        return true
    })

    const grupoPermisos = user?.grupo_permisos

    if(grupoPermisos){

        const modsGp = grupoPermisos?.modulos_grupos_permisos
        const modsKeys = []
        
        modsGp?.forEach(modGp => {
            modsKeys.push(modGp?.modulo?.mo_key)
        })

        // console.log('mod keys ',JSON.stringify(modsKeys))

        const newUserMenuConfig = []

        userMenuConfig.forEach(macroM => {

            const newMacro = cloneDeep(macroM)
            newMacro.items = []

            macroM.items?.forEach(itemM => {

                const newItem = cloneDeep(itemM)
                newItem.children = []

                const itKey = itemM.id
                
                // console.log('key: ',itKey)

                const chk = modsKeys?.filter(mk => (
                    mk === itKey
                ))[0] || null

                if(chk){

                    // console.log('!! si existe')

                    itemM.children?.forEach(ch => {
                        const newCh = cloneDeep(ch)

                        // console.log('key child ',ch.id)
                        
                        const chkCh = modsKeys?.filter(mkCh => (
                            mkCh === ch.id
                        ))[0] || null

                        if(chkCh){
                            // console.log('!! si existe child')
                            newItem.children.push(newCh)
                        }
                    })
                    if(!newItem.children.length){
                        delete newItem.children
                    }
                    newMacro.items.push(newItem)
                }
            })
            if(newMacro.items?.length){
                newUserMenuConfig.push(newMacro)
            }
        })
        // console.log(newUserMenuConfig)
     
        userMenuConfig = newUserMenuConfig
    }

    return { userMenuConfig } 
}

export { useRolMenu }
